import React from "react";
import Header from "../structure/Header/header.js";
import Footer from "../structure/Footer/footer.js";
import Gdpr from "../modules/Gdpr/gdpr.js";
// import FirebaseNotification from "../modules/firebase/FirebaseNotification.js";
import "./layout.scss";

function Layout({ children }) {
    return (
        <div>
            <Gdpr/>
            <Header />
            {children}
            <Footer />
        </div>
    )
}
export default Layout;